import { useLocale } from 'shared/presentation/contexts';

import { ModalWrapper, SubTitleModal, TitleModal } from '../styles';

interface IProps {
  title?: string;
  message?: string;
}

const ModalGeneric = ({ title, message }: IProps) => {
  const { t } = useLocale('translations');

  return (
    <ModalWrapper>
      <TitleModal>{title || t('components.modal.attention')}</TitleModal>
      <SubTitleModal>{message || t('common.error')}</SubTitleModal>
    </ModalWrapper>
  );
};

export default ModalGeneric;
